<script setup lang="ts">
import { useBrowserStore } from '@apps/main/new-desktop/core/stores';

import type { MapConfig } from '../../maps';
import { StaticMap } from '../../maps';
import type { ActivityDetailsMainData, Distance } from '../models';

import ActivityDetailsDescription from './ActivityDetailsDescription.vue';
import ActivityDetailsMapLoader from './loaders/ActivityDetailsMapLoader.vue';
import ActivityDetailsMainHeader from './ActivityDetailsMainHeader.vue';
import ActivityDetailsMainDescription from './ActivityDetailsMainDescription.vue';
import ActivityDetailsMainHeaderLoader from './loaders/ActivityDetailsMainHeaderLoader.vue';

const browserStore = useBrowserStore();

interface ActivityDetailsLeftPanelContentProps {
  isLoading: boolean;
  mainData: ActivityDetailsMainData;
  description: string | undefined;
  distances: Distance[] | undefined;
  mapConfiguration: MapConfig;
}

interface ActivityDetailsLeftPanelContentEmits {
  (event: 'open-dynamic-full-screen-map'): void;
}
const emit = defineEmits<ActivityDetailsLeftPanelContentEmits>();

const props = defineProps<ActivityDetailsLeftPanelContentProps>();
</script>

<template>
  <div class="activity-details-left-panel-content">
    <template v-if="browserStore.isSmallerThan900px">
      <ActivityDetailsMainHeaderLoader v-if="props.isLoading" />
      <ActivityDetailsMainHeader
        v-else-if="props.mainData"
        :main-info="props.mainData"
        :is-loading="props.isLoading"
      />
      <ActivityDetailsMainDescription
        class="main-description"
        :main-description="props.mainData.mainDescription"
      />
    </template>
    <ActivityDetailsDescription
      :is-loading="props.isLoading"
      :description="props.description"
      :distances="props.distances"
    />
    <ActivityDetailsMapLoader
      v-if="props.isLoading || !props.mapConfiguration.markers"
    />
    <StaticMap
      v-else
      :map-configuration="props.mapConfiguration"
      @zoom="emit('open-dynamic-full-screen-map')"
    />
  </div>
</template>

<style scoped lang="scss">
.main-description {
  text-align: center;
  @include font-body-s-light;
}
</style>
